import { render, staticRenderFns } from "./AreaMapEditor.vue?vue&type=template&id=0c331850&scoped=true&"
import script from "./AreaMapEditor.vue?vue&type=script&lang=js&"
export * from "./AreaMapEditor.vue?vue&type=script&lang=js&"
import style0 from "./AreaMapEditor.vue?vue&type=style&index=0&id=0c331850&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c331850",
  null
  
)

export default component.exports